import styled from 'styled-components';
import { AppLink } from '@finect/tabular-core/AppLink';
import { showAnimation } from '../../../commons/showAnimation';
export var Inner = styled(AppLink).withConfig({
  displayName: "Inner",
  componentId: "sc-dyyw33-0"
})(["display:block;flex-grow:1;flex-shrink:0;width:100%;border:1px solid ", ";border-radius:8px;box-shadow:", ";cursor:pointer;background-color:", ";", ";:hover{box-shadow:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.terciaryL;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.shadows.lightBlack;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.cardsBackgroundColor;
}, showAnimation, function (_ref4) {
  var theme = _ref4.theme;
  return theme.shadows.extraBlack;
});
export var InnerContainer = styled.div.withConfig({
  displayName: "Inner__InnerContainer",
  componentId: "sc-dyyw33-1"
})(["padding:24px;text-align:center;img{width:56px;height:56px;border-radius:", ";margin-bottom:8px;}"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.borderRadius;
});